






































































































































































































































































import _ from 'lodash'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import EventBus from '@/plugins/EventBus'
import moment from 'moment'

@Component
export default class ViewFinanceiroImpostoPrestador extends Vue {
  $refs!: { formItemImpostoPrestador: any }
  createOrEditMode: string = ''
  searchPrestadorFiltro: string = ''
  searchPrestadorModal: string = ''
  loadingPrestadorFilter: boolean = false
  ignoreNextPrestadorSearchFiltro: boolean = false
  ignoreNextPrestadorSearchModal: boolean = false
  suppressPrestadorSearch: boolean = false

  prestadoresDebounced = _.debounce(async (param: string) => {
    await this.getFinanceiroStore.getPrestadorTaxaAluguel({ filtro: param, limite: 20 })
  }, 700)

  loadEditarItemPontuacaoProfissional: string = ''
  get loadingEditarItemPontuacaoProfissional() { return this.loadEditarItemPontuacaoProfissional }
  set loadingEditarItemPontuacaoProfissional(value: string) { this.loadEditarItemPontuacaoProfissional = value }

  loadDataTable: boolean = false
  get loadingDataTable() { return this.loadDataTable }
  set loadingDataTable(value: boolean) { this.loadDataTable = value }

  loadDeleteItemPontuacaoProfissional: boolean = false
  get loadingDeleteImpostoPrestador() { return this.loadDeleteItemPontuacaoProfissional }
  set loadingDeleteImpostoPrestador(value: boolean) { this.loadDeleteItemPontuacaoProfissional = value }

  loadCadastroImpostoPrestador: boolean = false
  get loadingCadastroImpostoPrestador() { return this.loadCadastroImpostoPrestador }
  set loadingCadastroImpostoPrestador(value: boolean) { this.loadCadastroImpostoPrestador = value }

  itemToDelete: string = ''
  get itemToDeleteId() { return this.itemToDelete }
  set itemToDeleteId(value: string) { this.itemToDelete = value }

  modalDeleteItem: boolean = false
  get showModalDeleteItem() { return this.modalDeleteItem }
  set showModalDeleteItem(value: boolean) { this.modalDeleteItem = value }

  modalCriarItem: boolean = false
  get showModalCriarItem() { return this.modalCriarItem }
  set showModalCriarItem(value: boolean) { this.modalCriarItem = value }

  get prestadorSelecionadoId() { return this.getFinanceiroStore.prestadorIdFilter }
  set prestadorSelecionadoId(value: any) { this.getFinanceiroStore.setPrestadorIdFilter(value) }

  get impostoId() { return this.getFinanceiroStore.impostoId }
  set impostoId(value: string) { this.getFinanceiroStore.setImpostoId(value) }

  get alicota() { return this.getFinanceiroStore.alicota }
  set alicota(value: string) { this.getFinanceiroStore.setAlicota(value) }

  get valorMinimoTributo() { return this.getFinanceiroStore.valorMinimoTributo }
  set valorMinimoTributo(value: string) { this.getFinanceiroStore.setvalorMinimoTributo(value) }

  get pessoaId() { return this.getFinanceiroStore.pessoaId }
  set pessoaId(value: string) { this.getFinanceiroStore.setPessoaId(value) }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  formItemImpostoPrestadorRules: any = {
    valid: true,
    pessoaId: [(v: string) => v === '' || !!v || 'Campo obrigatório'],
    impostoId: [(v: string) => !!v || 'Campo obrigatório'],
    alicota: [(v: string) => !!v || 'Campo obrigatório'],
    valorMinimoTributo: [(v: string) => !!v || 'Campo obrigatório'],
  }

  get itemsTabelaImpostoPrestador() {
    return [
      { text: 'Prestador', value: 'pretador', align: 'left', sortable: false },
      { text: 'Criado em', value: 'createdOn', align: 'center', sortable: false },
      { text: 'Imposto', value: 'descricao', align: 'left', sortable: false },
      { text: 'Alíquota', value: 'alicota', align: 'left', sortable: false },
      { text: 'Ações', value: '', align: 'center', sortable: false },
    ]
  }

  get impostoPrestadores() {
    return this.getFinanceiroStore.impostoPrestadores
  }

  criarItemImpostoPrestador() {
    this.createOrEditMode = 'create'
    this.getFinanceiroStore.clearItemPontuacaoProfissional()
    this.showModalCriarItem = !this.showModalCriarItem
  }

  editarItemImpostoPrestador(item: any) {
    this.getFinanceiroStore.setIdForEditItemImpostoPrestador(item.id)
    this.createOrEditMode = 'edit'
    this.getFinanceiroStore.setEditItemImpostoPrestador(item)
    this.showModalCriarItem = !this.showModalCriarItem
  }

  setItemToDelete(id: string) {
    this.itemToDeleteId = id
    this.showModalDeleteItem = !this.showModalDeleteItem
  }

  async deleteImpostoPrestador() {
    this.loadingDeleteImpostoPrestador = true
    const response = await this.getFinanceiroStore.deleteImpostoPrestador(this.itemToDeleteId)
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: `Item apagado com sucesso! ${String.fromCodePoint(0x1f642)}`, icon: 'done', color: '#2E7D32' })
      await this.getAllItems()
      this.showModalDeleteItem = false
    } else {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: response.message ? `${response.message} ${String.fromCodePoint(0x1f615)}` : `Ocorreu um problema com essa requisição. ${String.fromCodePoint(0x1f615)}`,
        icon: 'warning',
        color: '#C62828',
      })
    }
    this.loadingDeleteImpostoPrestador = false
  }

  async getAllItems() {
    this.loadingDataTable = true
    await this.getFinanceiroStore.getImpostoPrestadores()
    this.loadingDataTable = false
  }

  async createImpostoPrestador() {
    this.loadingCadastroImpostoPrestador = true

    if (this.$refs.formItemImpostoPrestador.validate()) {
      if (this.createOrEditMode === 'create') {
        const request = await this.getFinanceiroStore.criarImpostoPrestador()
        if (request.success) {
          EventBus.$emit('setSnackbar', {
            show: true,
            text: `Item criado com sucesso! ${String.fromCodePoint(0x1f642)}`,
            icon: 'done',
            color: '#2E7D32',
          })
          this.getFinanceiroStore.clearItemImpostoPrestador()
          await this.getAllItems()
          this.showModalCriarItem = !this.showModalCriarItem
        } else {
          EventBus.$emit('setSnackbar', {
            show: true,
            text: request.message ? `${request.message} ${String.fromCodePoint(0x1f615)}` : `Ocorreu um erro na requisição... ${String.fromCodePoint(0x1f615)}`,
            icon: 'warning',
            color: '#C62828',
          })
        }
      }
      if (this.createOrEditMode === 'edit') {
        const request = await this.getFinanceiroStore.editarImpostoPrestador()
        if (request.success) {
          EventBus.$emit('setSnackbar', {
            show: true,
            text: `Item editado com sucesso! ${String.fromCodePoint(0x1f642)}`,
            icon: 'done',
            color: '#2E7D32',
          })
          this.getFinanceiroStore.clearItemImpostoPrestador()
          await this.getAllItems()
          this.showModalCriarItem = !this.showModalCriarItem
        } else {
          EventBus.$emit('setSnackbar', {
            show: true,
            text: request.message ? `${request.message} ${String.fromCodePoint(0x1f615)}` : `Ocorreu um erro na requisição... ${String.fromCodePoint(0x1f615)}`,
            icon: 'warning',
            color: '#C62828',
          })
        }
      }
    }
    this.loadingCadastroImpostoPrestador = false
  }

  async init() {
    EventBus.$emit('setLoadingRequest', { status: true, text: 'Carregando' })
    this.$refs.formItemImpostoPrestador.resetValidation()
    this.getFinanceiroStore.clearItemImpostoPrestador()
    this.getFinanceiroStore.setvalorMinimoTributo('0')
    this.getFinanceiroStore.setAlicota('0')
    this.getFinanceiroStore.setPrestadorIdFilter(null)
    await this.getFinanceiroStore.getPrestadorTaxaAluguel()
    await this.getFinanceiroStore.getImpostoPrestador()
    await this.getAllItems()
    EventBus.$emit('clearLoadingRequest')
  }

  formatData(date: Date | string) {
    return moment(date).format('DD/MM/YYYY HH:mm')
  }

  async mounted() {
    await this.init()
  }

  /**
   * Paginação
   */
  get itemsLength() {
    return Math.ceil(this.getFinanceiroStore.totalItemsImpostoPrestador / this.getFinanceiroStore.qtdPorPagina)
  }

  get visibleResults() {
    if (this.$vuetify.breakpoint.smAndDown) return 4
    if (this.$vuetify.breakpoint.md) return 7
    if (this.$vuetify.breakpoint.lg) return 9
    return 15
  }

  get getPagina() {
    return this.getFinanceiroStore.pagina
  }

  set getPagina(value: number) {
    this.getFinanceiroStore.setPagina(value)
  }

  async getResults(pagina: number) {
    this.loadingDataTable = true
    this.getPagina = pagina
    await this.getAllItems()
    this.loadingDataTable = false
  }

  @Watch('showModalCriarItem')
  async onCloseModalCriarItem(value) {
    if (!value) {
      this.getFinanceiroStore.clearItemImpostoPrestador()
      this.getFinanceiroStore.setvalorMinimoTributo('0')
      this.getFinanceiroStore.setAlicota('0')
      this.$refs.formItemImpostoPrestador.resetValidation()
      this.searchPrestadorModal = ''
    } else {
      this.suppressPrestadorSearch = true
      this.searchPrestadorModal = ''
      this.loadingPrestadorFilter = true
      await this.getFinanceiroStore.getPrestadorTaxaAluguel({ limite: 20 })
      this.loadingPrestadorFilter = false
      this.suppressPrestadorSearch = false
    }
  }

  @Watch('searchPrestadorFiltro')
  async onSearchPrestadorFiltroChanged(val: string) {
    if (this.suppressPrestadorSearch) {
      return
    }

    if (this.ignoreNextPrestadorSearchFiltro) {
      this.ignoreNextPrestadorSearchFiltro = false
      return
    }

    if (!val || val.length < 3) {
      this.getFinanceiroStore.setPrestadoresLista([])
      return
    }

    this.loadingPrestadorFilter = true
    if (this.prestadoresDebounced) await this.prestadoresDebounced(val)
    this.loadingPrestadorFilter = false
  }

  @Watch('searchPrestadorModal')
  async onSearchPrestadorModalChanged(val: string) {
    if (this.suppressPrestadorSearch) {
      return
    }

    if (this.ignoreNextPrestadorSearchModal) {
      this.ignoreNextPrestadorSearchModal = false
      return
    }

    if (!val || val.length < 3) {
      this.getFinanceiroStore.setPrestadoresLista([])
      return
    }

    this.loadingPrestadorFilter = true
    if (this.prestadoresDebounced) await this.prestadoresDebounced(val)
    this.loadingPrestadorFilter = false
  }

  onChangePrestadorFiltro() {
    this.ignoreNextPrestadorSearchFiltro = true
  }

  onChangePrestadorModal() {
    this.ignoreNextPrestadorSearchModal = true
  }

  @Watch('prestadorSelecionadoId')
  onPrestadorSelecionadoChange(value: string | null) {
    this.getResults(1)
  }
}
